import { formatDateTimeClientTimeZone } from "../components/detailedList/detailedMdls";
import { gloggedinuser, gnewcomp, gselectedgroup, gcustominvoiceinstructions, gextractionfieldlist, gcampaignconfig, gcampaignscheduleentry, gcampaignchatmemberrow, gactivecomp, gChatlogItem, gSyncLogItem, gscopedinvrule, glistview } from "../interfaces";
import {
    keyToDateUtc,
    safeJsonParse,
    addStampToCampaignChatMemberRows,
} from "../util_glob";



const getTokenMail = (token: any) => {
    return token.idTokenClaims?.emails?.length > 0 ? token.idTokenClaims?.emails[0] : token.idTokenClaims?.email;
};

const getTokenAccountID = (token: any) => {
    return token.uniqueId || token.localAccountId || token.oid;
};

export const qIsG = async (loggedInUser: gloggedinuser) => {
    const url = "/isG";
    const response = await fetch(url, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to Get G");

    let isG = await response.json();
    return isG;
};

export const qAddComp = async (loggedInUser: gloggedinuser, newComp: gnewcomp) => {
    const response = await fetch("/qAddComp", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify(newComp)
    });
    if (!response.ok) return response;

    let isG = await response.json();
    return isG;
};

export const qApprove = async (loggedInUser: gloggedinuser, fid: string, groupid: string) => {
    const response = await fetch(`/qApprove`, {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ fid: fid, approver_id: loggedInUser?.userId || "", group_id: groupid })
    })

    if (!response.ok) return response;

    let res = await response.json();
    return res;
};

export const qUpdateInvoiceStructuredData = async (loggedInUser: gloggedinuser, jsonData: any, fid: string, groupid: string, allowed_deviation: number) => {
    const response = await fetch("/q_update_strutured_json_data", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            fid: fid,
            json_data: jsonData,
            groupid: groupid,
            allowed_deviation: allowed_deviation
        })
    });

    if (!response.ok) return response;

    let res = await response.json();
    return res;
};

export const qAddInvInstrct = async (loggedInUser: gloggedinuser, tag: gcustominvoiceinstructions) => {
    const response = await fetch("/qAddInvInstrct", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            groupid: tag.groupid,
            contractorid: tag.contractorid,
            instruction: tag.instruction,
            fieldname: tag.fieldname
        })
    });
    if (!response.ok) return response;

    let res = await response.json();
    return res;
};

export const qGetInvInstrct = async (loggedInUser: gloggedinuser, groupid: string, contractorid: string, fieldname: string) => {
    const params = new URLSearchParams({ groupid: groupid, contractorid: contractorid, fieldname: fieldname });
    const url = "/qGetInvInstrct" + `?${params.toString()}`;
    const response = await fetch(url, {
        method: "GET",
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) return {};

    let res = await response.json();
    return res;
};

export const qDelInvInstrct = async (loggedInUser: gloggedinuser, iid: number) => {
    const response = await fetch("/qDelInvInstrct", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            iid: iid
        })
    });
    if (!response.ok) return response;

    let res = await response.json();
    return res;
};

export const qGetScopedInvRules = async (loggedInUser: gloggedinuser, groupid: string): Promise<gscopedinvrule[]> => {
    const response = await fetch(`/qGetScopedInvRules?groupid=${encodeURIComponent(groupid)}`, {
        method: "GET",
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) {
        import.meta.env.DEV === true && console.log("‹errr_get_scoped_rules›", response);
        return [];
    }
    import.meta.env.DEV === true && console.log("‹get_scoped_rules›");
    return await response.json();
};

export const qUpsertScopedInvRule = async (loggedInUser: gloggedinuser, rule: gscopedinvrule, groupid : string, orig_supplier_id?: string) => {
    const response = await fetch("/qUpsertScopedInvRule", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            supplier_id: rule.supplier_id,
            groupid : groupid ,
            info: rule.info ?? null,
            post_validation_rules: rule.post_validation_rules || {},
            pre_main_rules: rule.pre_main_rules || {},
            orig_supplier_id: orig_supplier_id ?? rule.supplier_id
        })
    });
    if (!response.ok) return response;
    return await response.json();
};

export const qDelScopedInvRule = async (loggedInUser: gloggedinuser, supplier_id: string, groupid: string) => {
    const response = await fetch("/qDelScopedInvRule", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ supplier_id, groupid })
    });
    if (!response.ok) return response;
    return await response.json();
};

export const getHeaderG = (loggedInUser: gloggedinuser, token?: any, rekey?: string) => {

    if (token) {
        return {
            ...(loggedInUser?.token ? { Authorization: `Bearer ${token.accessToken}` } : {}),
            "X-MS-CLIENT-PRINCIPAL-NAME": getTokenMail(token),
            "X-MS-CLIENT-PRINCIPAL-ID": getTokenAccountID(token),
            "Content-Type": "application/json",
            ...(rekey ? { rekey: rekey } : {})
        };
    } else {
        return {
            ...(loggedInUser?.token ? { Authorization: `Bearer ${loggedInUser.token}` } : {}),
            "X-MS-CLIENT-PRINCIPAL-NAME": loggedInUser?.mail ? loggedInUser.mail : "",
            "X-MS-CLIENT-PRINCIPAL-ID": loggedInUser?.userId ? loggedInUser.userId : "",
            "Content-Type": "application/json",
            ...(rekey ? { rekey: rekey } : {})
        };
    }
};

export const getHeaderGS = (loggedInUser: gloggedinuser, selectedSpace: gselectedgroup, token?: any) => {
    if (token) {
        return {
            ...(loggedInUser?.token ? { Authorization: `Bearer ${token.accessToken}` } : {}),
            "X-MS-CLIENT-PRINCIPAL-NAME": getTokenMail(token),
            "X-MS-CLIENT-PRINCIPAL-ID": getTokenAccountID(token),
            "Content-Type": "application/json",
            space_id: selectedSpace?.selectionId ? selectedSpace.selectionId : "",
            uid: loggedInUser?.userId ? loggedInUser.userId : ""
        };
    } else {
        return {
            ...(loggedInUser?.token ? { Authorization: `Bearer ${loggedInUser.token}` } : {}),
            "X-MS-CLIENT-PRINCIPAL-NAME": loggedInUser?.mail ? loggedInUser.mail : "",
            "X-MS-CLIENT-PRINCIPAL-ID": loggedInUser?.userId ? loggedInUser.userId : "",
            "Content-Type": "application/json",
            space_id: selectedSpace?.selectionId ? selectedSpace.selectionId : "",
            uid: loggedInUser?.userId ? loggedInUser.userId : ""
        };
    }
};



// LINK app/backend/qp.py#qSaveExtractionFieldList
export const qSaveExtractionFieldList = async (loggedInUser: gloggedinuser, selectedGroup: gselectedgroup, fieldConf: gextractionfieldlist, useApproval: Number, splitinv: Number) => {
    const response = await fetch("/qSaveExtractionFieldList", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            groupid: selectedGroup.selectionId,
            fieldconf: fieldConf,
            useapproval: useApproval,
            splitinv: splitinv
        })
    });
    if (!response.ok) return response;

    let res = await response.json();
    return res;
};


// 🧩 saved detailsList column views
// LINK app/backend/qp.py#qGetListViews
export const qGetListViews = async (loggedInUser: gloggedinuser, groupid: string): Promise<glistview[]> => {
    const params   = new URLSearchParams({ groupid });
    const response = await fetch(`/qGetListViews?${params.toString()}`, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) throw Error("qGetListViews¦Failed to Get Views");

    let views: glistview[] = await response.json();
    return views;
};

// LINK app/backend/qp.py#qSaveListView
export const qSaveListView = async (loggedInUser: gloggedinuser, view: Partial<glistview> & { groupid: string; is_default?: boolean }): Promise<glistview> => {
    const response = await fetch("/qSaveListView", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            id: view.id,
            groupid: view.groupid,
            viewname: view.viewname,
            viewcols: view.viewcols,
            ispublic: view.ispublic,
            is_default: view.is_default
        })
    });
    if (!response.ok) throw Error("qSaveListView¦Failed to Save View");

    let saved: glistview = await response.json();
    return saved;
};

// LINK app/backend/qp.py#qSetDefaultView
export const qSetDefaultView = async (loggedInUser: gloggedinuser, groupid: string, id: number | null, isDefault: boolean) => {
    const response = await fetch("/qSetDefaultView", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ id, groupid, is_default: isDefault })
    });
    if (!response.ok) throw Error("qSetDefaultView¦Failed to Set Default View");

    let res = await response.json();
    return res;
};

// LINK app/backend/qp.py#qDelListView
export const qDelListView = async (loggedInUser: gloggedinuser, id: number) => {
    const response = await fetch("/qDelListView", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ id })
    });
    if (!response.ok) throw Error("qDelListView¦Failed to Delete View");

    let res = await response.json();
    return res;
};


// LINK app/backend/qp.py#qGetChatLog
export const qGetChatLog = async (aggC: number, selgroup: gselectedgroup, loggeduser: gloggedinuser, activeComp: gactivecomp) => {
    const params = new URLSearchParams({
        compid: activeComp.companyid,
        ...(aggC < 1 ? { groupid: selgroup.selectionId } : {})
    });
    const response = await fetch("/qGetChatLog" + `?${params.toString()}`, { headers: getHeaderG(loggeduser) });

    if (!response.ok) throw Error("qGetChatLog¦Failed to Get Log");

    let rspns = await response.json();
    rspns = rspns.map((item: any) => ({
        ...item,
        datestamp: keyToDateUtc(item.key),
        collecteddata: safeJsonParse(item.collecteddata),
        audio_logs: safeJsonParse((item.audio_logs || "[]").replace(/^'(.*)'$/, "$1"))
    }));
    let spaceChatLog: gChatlogItem[] = rspns;

    return spaceChatLog;
};

// LINK app/backend/qp.py#qGetSyncLog
export const qGetSyncLog = async (aggC: number, selgroup: gselectedgroup, loggeduser: gloggedinuser, activeComp: gactivecomp) : Promise<gSyncLogItem[]> => {
    const params = new URLSearchParams({
        compid: activeComp.companyid,
        ...(aggC < 1 ? { groupid: selgroup.selectionId } : {})
    });
    const response = await fetch("/qGetSyncLog" + `?${params.toString()}`, { headers: getHeaderG(loggeduser) });

    if (!response.ok) throw Error("‹errr_q_getlog_get›");
    let rspns = await response.json();

    rspns.map((item: any) => ({
        ...item,
        stamp: formatDateTimeClientTimeZone(item.stamp)
    }));

    let spaceSyncLog: gSyncLogItem[] = rspns;

    spaceSyncLog = spaceSyncLog.filter(sync => sync.doctype != "data"); // filter out data nomenclature syncs

    return spaceSyncLog;
};



// ─── Campaigns ───────────────────────────────────────────────────

export const qGetCampaigns = async (loggedInUser: gloggedinuser, space_id: string) => {
    // LINK app/backend/qp.py#qGetCampaigns

    const params = new URLSearchParams({ space_id });
    const response = await fetch(`/qGetCampaigns?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get campaigns");
    let campaigns = await response.json();
    for (let camp of campaigns) {
        try{
            camp.campaign_config = (JSON.parse(camp.campaign_config)) as gcampaignconfig;
        } catch {
            console.warn(`Failed to parse config for campaign ${camp.campaign_id}, using empty config`);
        }
    }
    return campaigns;
};

export const qSendCampaignInvites = async (loggedInUser: gloggedinuser, campaign_id: string, space_id: string, message?: string) => {
    // LINK app/backend/qp.py#qSendCampaignInvites
    const response = await fetch("/qSendCampaignInvites", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ campaign_id, space_id, kgnfdom: window.location.host, ...(message ? { message } : {}) })
    });
    if (!response.ok) throw Error("Failed to send campaign invites");
    return await response.json();
};


// ANCHOR[id=qGetCampaignChatMembers] Get campaign chat members
export const qGetCampaignChatMembers = async (loggedInUser: gloggedinuser, campaign_id: string, space_id: string): Promise<gcampaignchatmemberrow[]> => {
    // LINK app/backend/qp.py#qGetCampaignChatMembers
    const params = new URLSearchParams({ campaign_id, space_id });
    const response = await fetch(`/qGetCampaignChatMembers?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get campaign chat members");
    let rows = await response.json();
    rows = (rows as any[]).map((r: any) => ({ ...r, collecteddata: safeJsonParse(r.collecteddata) }));

    rows = addStampToCampaignChatMemberRows(rows as gcampaignchatmemberrow[]);
    console.log("‹campaign_chat_members›", rows);


    return rows as gcampaignchatmemberrow[];
};

// LINK app/backend/qp.py#qAddCampaign
export const qAddCampaign = async (loggedInUser: gloggedinuser, space_id: string, campaign_config: gcampaignconfig, campaign_id?: string, campaign_start_date?: string, campaign_end_date?: string, campaign_display_name?: string, is_inactive?: number) => {
    const response = await fetch("/qAddCampaign", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ space_id, campaign_config, ...(campaign_id ? { campaign_id } : {}), ...(campaign_start_date ? { campaign_start_date } : {}), ...(campaign_end_date ? { campaign_end_date } : {}), ...(campaign_display_name ? { campaign_display_name } : {}), ...(is_inactive !== undefined ? { is_inactive } : {}) })
    });
    if (!response.ok) throw Error("Failed to save campaign");
    return await response.json();
};

export const qDelCampaign = async (loggedInUser: gloggedinuser, campaign_id: string) => {
    const response = await fetch("/qDelCampaign", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ campaign_id })
    });
    if (!response.ok) throw Error("Failed to delete campaign");
    return await response.json();
};

export const parseCampaignTargetSchedules = (schedules: string): Record<string, gcampaignscheduleentry[] | null> => {
    const arr = JSON.parse(schedules) as Record<string, gcampaignscheduleentry[] | null>;

    return arr;
};

export const qGetAllCampaignTargets = async (loggedInUser: gloggedinuser, space_id: string) => {
    // LINK app/backend/qp.py#qGetAllCampaignTargets

    const params = new URLSearchParams({ space_id });
    const response = await fetch(`/qGetAllCampaignTargets?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get all campaign targets");
    return await response.json();
};

export const qGetCampaignTargets = async (loggedInUser: gloggedinuser, campaign_id: string) => {
    // LINK app/backend/qp.py#qGetCampaignTargets

    const params = new URLSearchParams({ campaign_id });
    const response = await fetch(`/qGetCampaignTargets?${params.toString()}`, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) throw Error("Failed to get campaign targets");
    return await response.json();
};

export const qGetUP = async (loggedInUser: gloggedinuser, caid: string) => {
    // LINK app/backend/qp.py#qGetUP

    const params = new URLSearchParams({ caid });
    const response = await fetch(`/qGetUP?${params.toString()}`, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) throw Error("Failed to get UP");

    return await response.json();
};

export const qGetCampaignTargetFids = async (loggedInUser: gloggedinuser, space_id: string): Promise<string[]> => {
    // LINK app/backend/qp.py#qGetCampaignTargetFids
    const params = new URLSearchParams({ space_id });
    const response = await fetch(`/qGetCampaignTargetFids?${params.toString()}`, { headers: getHeaderG(loggedInUser) });
    if (!response.ok) throw Error("Failed to get campaign target fids");
    return await response.json();
};

export const getBaseAiData = async (loggedInUser: gloggedinuser, selectedGroup: gselectedgroup, fid: string) => {
    // LINK app/backend/app.py#get_base_ai_data
    const params = new URLSearchParams({ fid });
    const response = await fetch(`/get_base_ai_data?${params.toString()}`, {
        headers: {
            ...getHeaderG(loggedInUser),
            gid: selectedGroup.selectionId || "",
            user_id: loggedInUser?.userId || ""
        }
    });
    if (!response.ok) throw Error("Failed to get base AI data");
    return await response.json();
};

// update base extraction content (fileautomation.invoicedata) from human edits
export const qUpdateBaseContent = async (loggedInUser: gloggedinuser, gid: string, fid: string, content: any): Promise<boolean> => {
    // LINK app/backend/qp.py#qUpdateBaseContent
    const response = await fetch("/qUpdateBaseContent", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ fid, gid, content })
    });
    return response.ok;
};

// save user add/edit/delete of linked PO source data (po_line_items) then get the rebuilt rows back
// LINK app/backend/kgnf_po_track_v1.py#po_track_v1_edit
export const qSaveLinkedDataEdits = async (
    loggedInUser: gloggedinuser,
    gid: string,
    fid: string,
    upserts: any[],
    deletes: (string | number)[]
): Promise<{ status: string; touched?: number; rows?: any[]; message?: string }> => {
    const response = await fetch("/po_track_v1_edit", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ fid, gid, upserts, deletes })
    });
    if (!response.ok) return { status: "error" };
    return await response.json();
};

// force-rebuild ONE linked list file's invoicedata from the live po_line_items rows (per sidebar tab)
// LINK app/backend/kgnf_po_track_v1.py#po_track_v1_refresh_file
export const qRefreshLinkedData = async (
    loggedInUser: gloggedinuser,
    gid: string,
    fid: string
): Promise<{ status: string; fid?: number; count?: number; rows?: any[]; message?: string }> => {
    const response = await fetch("/po_track_v1_refresh_file", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ gid, fid })
    });
    if (!response.ok) return { status: "error" };
    return await response.json();
};


// 🕰️ list available invoicedata versions for a file (no payload)
export const qGetVersions = async (loggedInUser: gloggedinuser, fid: string) => {
    // LINK app/backend/qp.py#qGetVersions
    const params = new URLSearchParams({ fid });
    const response = await fetch(`/qGetVersions?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get versions");
    return await response.json();
};


// 🕰️ get a single previous invoicedata version payload
export const qGetVersionData = async (loggedInUser: gloggedinuser, version_id: string) => {
    // LINK app/backend/qp.py#qGetVersionData
    const params = new URLSearchParams({ version_id });
    const response = await fetch(`/qGetVersionData?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get version data");
    return await response.json();
};


// 🕰️ download an original uploaded (rehydrate) file version directly (no streaming)
export const downloadVersionFile = async (loggedInUser: gloggedinuser, companyId: string, blobpath: string, filename: string) => {
    // LINK app/backend/app.py#download_version_file
    const params = new URLSearchParams({ companyid: companyId, blobpath, filename });
    try {
        const response = await fetch(`/download_version_file?${params.toString()}`, {
            method: "GET",
            headers: getHeaderG(loggedInUser)
        });
        if (!response.ok) throw new Error(`HTTP error ${response.status}`);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.style.display = "none";
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 3000);
    } catch (error) {
        console.error("Version download failed:", error);
        throw error;
    }
};




export const qAddCampaignTargets = async (
        loggedInUser: gloggedinuser,
        campaign_id: string,
        targets: {
            target_id: string;
            target_name: string;
            target_phone_number: string;
            target_email?: string;
            target_position?: string;
            target_campaign_fids?: Record<string, string[]>[];
            target_meta?: Record<string, any>
        }[]
    ) => {
        const response = await fetch("/qAddCampaignTargets", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ campaign_id, targets })
    });
    if (!response.ok) throw Error("Failed to add campaign targets");
    let res = await response.json();
    return res;
};

export const qRemoveCampaignTarget = async (loggedInUser: gloggedinuser, campaign_id: string, target_id: string) => {
    const response = await fetch("/qRemoveCampaignTarget", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ campaign_id, target_id })
    });
    if (!response.ok) throw Error("Failed to remove campaign target");
    return await response.json();
};

export const qUpdateCampaignTarget = async (
        loggedInUser: gloggedinuser,
        target_id: string,
        target_name: string,
        target_phone_number: string,
        target_email: string,
        target_position?: string
    ) => {
    const response = await fetch("/qUpdateCampaignTarget", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
             target_id,
             target_name,
             target_phone_number,
             target_email,
             ...(target_position !== undefined ? { target_position } : {})
        })
    });
    if (!response.ok) throw Error("Failed to update contact");
    return await response.json();
};

// LINK app/backend/app.py#kgnf_ai_match_position
export const qAiMatchPosition = async (
        loggedInUser: gloggedinuser,
        space_id: string,
        file_meta: { fileid: string; name: string }[],
        targets: { target_id: string; position: string }[]
    ): Promise<{ target_id: string; position: string; fileid: string }[]> => {
    const response = await fetch("/kgnf_ai_match_position", {
        method: "POST",
        headers: { ...getHeaderG(loggedInUser), space_id },
        body: JSON.stringify({ file_meta, targets })
    });
    if (!response.ok) throw Error("Failed to match positions to documents");
    const res = await response.json();
    return (res?.result?.matches ?? []) as { target_id: string; position: string; fileid: string }[];
};

export const qGetCampaignProgress = async (loggedInUser: gloggedinuser, campaign_id: string) => {
    const params = new URLSearchParams({ campaign_id });
    const response = await fetch(`/qGetCampaignProgress?${params.toString()}`, {
        headers: getHeaderG(loggedInUser)
    });
    if (!response.ok) throw Error("Failed to get campaign progress");
    return await response.json();
};

export const qScheduleCampaign = async (
        loggedInUser: gloggedinuser,
        campaign_id: string,
        space_id: string,
        company_id: string,
        call_window_start?: string,
        call_window_end?: string,
        test_start_offset_min?: number,
        test_step_min?: number,
    ) => {
    const response = await fetch("/qScheduleCampaign", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({
            campaign_id,
            space_id,
            company_id,
            ...(call_window_start ? { call_window_start } : {}),
            ...(call_window_end   ? { call_window_end   } : {}),
            ...(test_start_offset_min !== undefined ? { test_start_offset_min } : {}),
            ...(test_step_min !== undefined ? { test_step_min } : {}),
        })
    });
    if (!response.ok) throw Error("Failed to schedule campaign");
    return await response.json();
};

export const qRescheduleTarget = async (
        loggedInUser: gloggedinuser,
        target_id: string,
        campaign_id: string,
        space_id: string,
        company_id: string,
        new_date: string,
    ) => {
    const response = await fetch("/qRescheduleTarget", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ target_id, campaign_id, space_id, company_id, new_date })
    });
    if (!response.ok) throw Error("Failed to reschedule target");
    return await response.json() as { status: string; scheduled_time: string };
};

export const qUpdateScheduleState = async (
        loggedInUser: gloggedinuser,
        target_id: string,
        campaign_id: string,
        state: string,
        extras?: {
            scheduled_time?: string;
            job_id?:         string;
            convo_id?:       string;
            delay_info?:     string;
            delay_greeting?: string;
        }
    ) => {
    const response = await fetch("/qUpdateScheduleState", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ target_id, campaign_id, state, ...(extras || {}) })
    });
    if (!response.ok) throw Error("Failed to update schedule state");
    return await response.json();
};

export const qSetDefCampaign = async (loggedInUser: gloggedinuser, groupid: string, def_campaign_id: string) => {
    const response = await fetch("/qSetDefCampaign", {
        method: "POST",
        headers: getHeaderG(loggedInUser),
        body: JSON.stringify({ groupid, def_campaign_id })
    });
    if (!response.ok) throw Error("Failed to set default campaign");
    return await response.json();
};
